import React from "react";
import { StyleSheet, View } from "react-native";
import {
  CircleHelp,
  Stethoscope,
  ThumbsDown,
  ThumbsUp,
  X,
} from "lucide-react-native";

import {
  RectangularOptionButton,
  SquareOptionButton,
} from "@src/packages/medical-history/components";

type YesNoOptionsProps = {
  bottomSpacing?: number;
  noLabel: string;
  onChange: (value: boolean) => void;
  value: boolean | null;
  yesLabel: string;
};

export function YesNoOptions({
  bottomSpacing = 40,
  noLabel,
  onChange,
  value,
  yesLabel,
}: YesNoOptionsProps) {
  return (
    <View style={[styles.optionsContainer, { marginBottom: bottomSpacing }]}>
      <SquareOptionButton
        icon={ThumbsUp}
        isSelected={value === true}
        label={yesLabel}
        onPress={() => onChange(true)}
      />
      <SquareOptionButton
        icon={ThumbsDown}
        isSelected={value === false}
        label={noLabel}
        onPress={() => onChange(false)}
      />
    </View>
  );
}

export type DiagnosisStatus = "diagnosed" | "no" | "suspected";

type DiagnosisStatusOptionsProps = {
  diagnosedLabel: string;
  noLabel: string;
  onChange: (value: DiagnosisStatus) => void;
  suspectedLabel: string;
  value: DiagnosisStatus | null;
};

export function DiagnosisStatusOptions({
  diagnosedLabel,
  noLabel,
  onChange,
  suspectedLabel,
  value,
}: DiagnosisStatusOptionsProps) {
  return (
    <View style={styles.diagnosisOptionsContainer}>
      <View style={styles.optionsContainer}>
        <SquareOptionButton
          icon={Stethoscope}
          isSelected={value === "diagnosed"}
          label={diagnosedLabel}
          onPress={() => onChange("diagnosed")}
        />
        <SquareOptionButton
          icon={X}
          isSelected={value === "no"}
          label={noLabel}
          onPress={() => onChange("no")}
        />
      </View>
      <RectangularOptionButton
        icon={CircleHelp}
        isSelected={value === "suspected"}
        label={suspectedLabel}
        onPress={() => onChange("suspected")}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  diagnosisOptionsContainer: {
    gap: 12,
    marginBottom: 40,
    width: "100%",
  },
  optionsContainer: {
    flexDirection: "row",
    gap: 12,
    width: "100%",
  },
});
